import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-bold-arrow-right',
  imports: [],
  templateUrl: './icon-bold-arrow-right.component.html',
})
export class IconBoldArrowRightComponent {
  @Input() color: string = 'currentColor';
  @Input() size: string = '24';
}
